import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { Service, Group } from '../domain/Service';

export interface ListServiceResponse {
  services: Service[];
  groups: Group[];
}

@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  private readonly http = inject(HttpClient);


  public list(): Observable<any> {
    return this.http.get('service/list').pipe(
      map((data: ListServiceResponse) => {
        return data;
      }),
      tap());
  }
}
